export default "__VITE_ASSET__37fe3313__"